var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ml-2 dropdown show" }, [
    _c(
      "a",
      {
        staticClass: "text-primary bold dropdown-toggle dropdown-small-height",
        attrs: {
          id: "nearing-apps-dropdown",
          role: "button",
          "data-toggle": "dropdown",
        },
      },
      [_vm._v("\n    " + _vm._s(_vm.computedDropdownDisplayText) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "dropdown-menu",
        attrs: { id: "nearing-apps-state-filter" },
      },
      [
        _vm.allowSearch
          ? _c("div", { staticClass: "px-4" }, [
              _c(
                "div",
                { staticClass: "right-inner-addon mb-2" },
                [
                  _c("icon", { attrs: { name: "search" } }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.search,
                        expression: "search",
                        modifiers: { trim: true },
                      },
                    ],
                    staticClass: "form-control search-inactive-clients",
                    attrs: {
                      id: "search-for-agents-input",
                      type: "search",
                      placeholder: "" + _vm.$t("agents.searchFor"),
                      autocomplete: "off",
                    },
                    domProps: { value: _vm.search },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.search = $event.target.value.trim()
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "d-none",
                      attrs: { for: "search-for-agents-input" },
                    },
                    [_vm._v(_vm._s(_vm.$t("agents.searchFor")))]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.agentsListFiltered, function (agent) {
          return _c(
            "a",
            {
              key: "agent-" + agent.username,
              staticClass: "clickable dropdown-item dropdown-item--filter",
              on: {
                click: function ($event) {
                  return _vm.handleClick(agent)
                },
              },
            },
            [_vm._v("\n      " + _vm._s(agent.displayName))]
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }